function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#012169"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15 7.5 13.322 7.5 7.5 10.411 1.678 7.5 0 7.5 0 8.338 5.822 11.249 0 14.161 0 15 .335 15.67 7.5 12.088 14.664 15.67 15.336 14.329 9.177 11.249 15.336 8.17 15 7.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15 7.5 13.881 7.5 7.5 10.69 1.12 7.5 0 7.5 0 8.059 6.382 11.249 0 14.44 0 14.999 .223 15.447 7.5 11.809 14.777 15.447 15.224 14.552 8.617 11.249 15.224 7.947 15 7.5",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.75 17.5 6.25 17.5 6.25 12.499 0 12.499 0 10 6.25 10 6.25 7.5 8.75 7.5 8.75 10 17.5 10 17.5 12.499 8.75 12.499 8.75 17.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.249 17.5 6.75 17.5 6.75 12 0 12 0 10.499 6.75 10.499 6.75 7.5 8.249 7.5 8.249 10.499 17.5 10.499 17.5 12 8.249 12 8.249 17.5",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,7.5h15v15H0v-7.5h15s0-7.5,0-7.5Z",
    style: {
      fill: "#fedd00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 11.249,
    r: 1.276,
    style: {
      fill: "#012169"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M7.5,9.973l.75,2.309-1.964-1.427h2.427l-1.964,1.427",
    style: {
      fill: "#fedd00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b1",
    "data-name": "b",
    d: "M3.125,10.572l.441,1.357-1.154-.838h1.427l-1.154.838",
    style: {
      fill: "#fedd00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b2",
    "data-name": "b",
    d: "M11.874,10.572l.441,1.357-1.154-.838h1.427l-1.154.838",
    style: {
      fill: "#fedd00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b3",
    "data-name": "b",
    d: "M7.5,13.073l.441,1.357-1.154-.838h1.427l-1.154.838",
    style: {
      fill: "#fedd00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b4",
    "data-name": "b",
    d: "M7.5,8.072l.441,1.357-1.154-.838h1.427l-1.154.838",
    style: {
      fill: "#fedd00"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNu);
export default __webpack_public_path__ + "static/media/NU.5149df10eee0482685771ab832ba3bb7.svg";
export { ForwardRef as ReactComponent };